import Calendar from '@/containers/calendar/Index';

import { ROUTE_CALENDAR } from './names';


export default [
    {
        path: '/calendar',
        name: ROUTE_CALENDAR,
        component: Calendar,
        meta: {
            auth: true,
            title: '日历排期',
        },
    },
];



// WEBPACK FOOTER //
// ./src/router/calendar.js